<template>
        <div class="container has-text-white">
           <div class="bottom20">&nbsp;</div>
            <H1 class="has-text-white is-size-3">EMAIL UNVERIFIED</H1>
                <div class="limitWidth">
                    <hr/>
                </div>
                <div class="limitWidth">
                <div class="subtitle has-text-white">
                    Your Email has not been Verified!
                </div>
                <p>
                    Please check your email for a confirmation and instructions on how to verify your account.
                    After doing so, click the button below to login.
                </p>
                <p class="top10">
                    If you have not received the email in your inbox please check your junk-email. You can also click
                    <span class="has-text-warning handCursor" @click="resend">here</span> to have it resent.
                </p>
                <p v-show="showMsg" class="has-text-weight-bold top10">
                    A new confirmation email has been sent to your email address.
                </p>
                <div class="top20 bottom40">
                    <button class="button is-coolGreen" @click="$root.showModalLogin({})">LOG IN</button>
                </div>
            </div>
        </div>
</template>

<script>

var AmazonCognitoIdentity = require('amazon-cognito-identity-js')
export default {
  components: {

  },
  data: function () {
    return {
      showMsg: false
    }
  },
  methods: {
    resend: function () {
      var self = this
      this.showMsg = false

      this.$root.app.azCognito.resendConfirmationCode(this.$root.app.userAttrs.email, resendCallback)

      function resendCallback (result, obj) {
        if (result == 'success') {
          self.showMsg = true
        } else if (result == 'error') {
          self.$root.showModalOK({message: 'There was an error resending the verificatoin email.'})
        }
      }
    }
  }
}
</script>

<style scoped>
    a {
        font-weight: bold;
    }
    a:hover{
        color:gold
    }
</style>
